export default __webpack_public_path__ + "static/Ovidiu-da2adbbf726a27719e7b246a499422f6.png";